<template>
    <router-view />
  </template>
  
  <script>
  import { unRegisterMixin } from '@/mixin/storeGenerator';
  
  export default {
    name: 'WrapperInventoryOrderBooks',
    mixins: [unRegisterMixin],
    data() {
      return {
        moduleName: 'inventoryOrderBooksModule',
      };
    },
  };
  </script>
  